import { redirect } from '../redirect';

export const onInsuranceEnd = {
  action: redirect,
};
